import { render, staticRenderFns } from "./ContactActionsMenu.vue?vue&type=template&id=36d85336&scoped=true&"
import script from "./ContactActionsMenu.vue?vue&type=script&lang=js&"
export * from "./ContactActionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContactActionsMenu.vue?vue&type=style&index=0&id=36d85336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d85336",
  null
  
)

export default component.exports